const aaa = [
	{
		path: "pinpaiList",
		component: () => import("@/views/pinpai/pinpaiList.vue"),
		meta:{title:'品牌'},
	},
]
export default aaa;